import http from './http'
import { getToken } from './auth'

const base = 'CashflowTransactions'

export const getPaginatedCashflowTransactions = async (pageNumber, pageSize, startDate, endDate) => {

    const params = new URLSearchParams()
    params.append('pageNumber', pageNumber)
    params.append('pageSize', pageSize)

    startDate && params.append('startDate', startDate.toISOString())
    endDate && params.append('endDate', endDate.toISOString())

    const { data } = await http.get(`${base}/`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    })
    return data
}